<template>
    <div id="help-box" class="help-box" v-if="filteredData.length">
        <div v-show="helpBoxOpened" id="help-box-items">
            <div class="help-box__items">
                <div v-for="(item, index) in filteredData" :key="index">
                    <div v-if="item.type == 'file'">
                        <a :href="item.url" target="_blank">
                            <div class="help-box__item">
                                {{ item.label }}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="help-box__button--round" @click="toggleHelpBox">
            <div class="nav-user-bubble__link">
                {{ trans('menu.support') }}

                <svg
                    width="15"
                    height="15"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        style="fill: white;"
                        d="m512 346.5c0-63.535156-36.449219-120.238281-91.039062-147.820312-1.695313 121.820312-100.460938 220.585937-222.28125 222.28125 27.582031 54.589843 84.285156 91.039062 147.820312 91.039062 29.789062 0 58.757812-7.933594 84.210938-23.007812l80.566406 22.285156-22.285156-80.566406c15.074218-25.453126 23.007812-54.421876 23.007812-84.210938zm0 0"
                    />
                    <path
                        style="fill: white"
                        d="m391 195.5c0-107.800781-87.699219-195.5-195.5-195.5s-195.5 87.699219-195.5 195.5c0 35.132812 9.351562 69.339844 27.109375 99.371094l-26.390625 95.40625 95.410156-26.386719c30.03125 17.757813 64.238282 27.109375 99.371094 27.109375 107.800781 0 195.5-87.699219 195.5-195.5zm-225.5-45.5h-30c0-33.085938 26.914062-60 60-60s60 26.914062 60 60c0 16.792969-7.109375 32.933594-19.511719 44.277344l-25.488281 23.328125v23.394531h-30v-36.605469l35.234375-32.25c6.296875-5.761719 9.765625-13.625 9.765625-22.144531 0-16.542969-13.457031-30-30-30s-30 13.457031-30 30zm15 121h30v30h-30zm0 0"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { onClickOutside } from '../util/onClickOutside';

export default {
    props: ['roles'],

    data() {
        return {
            helpBoxOpened: false,
            data: [
                {
                    type: 'file',
                    label: this.trans('help.headline'),
                    url: 'https://dekrasafetyweb.zendesk.com/hc/de',
                    roles: [
                        'controller',
                        'end_user',
                        'supervisor',
                        'client_admin',
                    ],
                },
                {
                    type: 'file',
                    label: this.trans('help.label.clientadmin.documentation'),
                    url: '/files/DEKRA_SafetyWeb_Handbuch-Admin.pdf',
                    roles: ['client_admin', 'supervisor'],
                },
            ],
        };
    },

    methods: {
        toggleHelpBox() {
            this.helpBoxOpened = !this.helpBoxOpened;
        },
    },

    computed: {
        filteredData() {
            return this.data.filter(item => {
                let intersection = item.roles.filter(role =>
                    this.roles.includes(role)
                );
                return intersection.length;
            });
        },
        iconUrl() {
            return `/images/icons/help.svg`;
        },

        iconAlt() {
            return `toggle help box`;
        },
    },

    mounted() {
        if (this.filteredData.length) {
            onClickOutside(document.getElementById('help-box'), () => {
                this.helpBoxOpened = false;
            });
        }
    },
};
</script>
